import { FC } from "react";

import { PageClientSideFilters } from "@ryde/layout";

import { CourseCrudRoutes } from "../crud";
import { CoursesGridBottomWidget } from "./courses-grid-bottom-widget";

export const CoursesPageGrid: FC = () => (
  <>
    <PageClientSideFilters
      BottomWidgetComponent={<CoursesGridBottomWidget />}
    />
    <CourseCrudRoutes />
  </>
);
